import React from "react";
import Filter from '../../../components/CRM/Filter';
import {connect} from "react-redux";
import TextInput from "../../../components/CRM/TextInput";
import NullableBooleanInput from "../../../components/CRM/NullableBooleanInput";

const PartnerFilterBase = props => {
  props.record.list.ids.forEach((pair, index) => {
    const slipId = pair;
    if (slipId && props.record.data[slipId] !== null) {
      props.record.data[slipId].full_name =
        props.record.data[slipId].first_name +
        " " +
        props.record.data[slipId].last_name;
    }
  });

  return (
    <Filter {...props}>
      <TextInput
        label="resources.storeOwners.search"
        source="first_name_like"
      />
      <TextInput
        label="resources.storeOwners.filter_last_name"
        source="last_name_like"
      />

      <TextInput
        label="resources.storeOwners.inputs.email"
        source="email_like"
      />

      <TextInput
        label="resources.storeOwners.inputs.companyName"
        source="company_name_like"
      />

      <TextInput label="resources.storeOwners.inputs.city" source="city_like" />

      <TextInput
        label="resources.storeOwners.inputs.postNumber"
        source="post_number_like"
      />

      <NullableBooleanInput
        label="resources.storeOwners.inputs.active"
        source="active"
        defaultValue={true}
      />
    </Filter>
  );
};

const mapStateToProps = state => {
  return {
    record: state.admin.resources.partners
  };
};

const PartnerFilter = connect(mapStateToProps)(PartnerFilterBase);

export default PartnerFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/PartnerFilter.js